<template>
  <div class="footer-container10">
    <footer id="footer-korpus" class="footer-section">
      <div class="footer-container">
        <div class="footer-main">
          <div class="footer-column footer-brand">
            <div class="footer-logo-wrapper">
              <img :alt="imageAlt" :src="imageSrc" class="footer-image" />
            </div>
            <p class="footer-tagline">{{ $t('footer.tagline') }}</p>
            <div class="footer-badges">
              <div class="footer-badge">
                <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                  <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                <span>{{ $t('footer.badges.oneClick') }}</span>
              </div>
              <div class="footer-badge">
                <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                  <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                <span>{{ $t('footer.badges.restApi') }}</span>
              </div>
              <div class="footer-badge">
                <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                  <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                <span>{{ $t('footer.badges.worksMachines') }}</span>
              </div>
            </div>
          </div>
          <div class="footer-column">
            <h4 class="footer-heading">{{ $t('footer.headings.product') }}</h4>
            <nav class="footer-nav">
              <a href="#">
                <div class="footer-link"><span>{{ $t('footer.links.parametricDesign') }}</span></div>
              </a>
              <a href="#">
                <div class="footer-link"><span>{{ $t('footer.links.oneClickCnc') }}</span></div>
              </a>
              <a href="#">
                <div class="footer-link"><span>{{ $t('footer.links.automaticLabeling') }}</span></div>
              </a>
              <a href="#">
                <div class="footer-link"><span>{{ $t('footer.links.batchProduction') }}</span></div>
              </a>
              <a href="#">
                <div class="footer-link"><span>{{ $t('footer.links.materialsEdges') }}</span></div>
              </a>
              <a href="#">
                <div class="footer-link"><span>{{ $t('footer.links.integrations') }}</span></div>
              </a>
            </nav>
          </div>
          <div class="footer-thq-footer-column-elm3 footer-column">
            <h4 class="footer-heading">{{ $t('footer.headings.solutions') }}</h4>
            <nav class="footer-nav">
              <a href="#">
                <div class="footer-link"><span>{{ $t('footer.links.smallShops') }}</span></div>
              </a>
              <a href="#">
                <div class="footer-link"><span>{{ $t('footer.links.growingTeams') }}</span></div>
              </a>
              <a href="#">
                <div class="footer-link"><span>{{ $t('footer.links.largerFactories') }}</span></div>
              </a>
              <a href="#">
                <div class="footer-thq-footer-link-elm19 footer-link"><span>{{ $t('footer.links.pricing') }}</span></div>
              </a>
              <a href="#">
                <div class="footer-link"><span>{{ $t('footer.links.customerStories') }}</span></div>
              </a>
            </nav>
          </div>
          <div class="footer-column">
            <h4 class="footer-heading">{{ $t('footer.headings.company') }}</h4>
            <nav class="footer-nav">
              <a href="#">
                <div class="footer-link"><span>{{ $t('footer.links.aboutUs') }}</span></div>
              </a>
              <a href="https://vlecad.com" target="_blank" rel="noreferrer noopener">
                <div rel="noopener" target="_blank" class="footer-link">
                  <span>VLECAD®</span>
                </div>
              </a>
              <a href="https://www.autofitsoftware.com/" target="_blank" rel="noreferrer noopener">
                <div rel="noopener" target="_blank" class="footer-link">
                  <span>AutoFIT</span>
                </div>
              </a>
              <router-link to="/contactdemo">
                <div class="footer-thq-footer-link-elm24 footer-link">
                  <span @click="scrollToTop">{{ $t('footer.links.contact') }}</span>
                </div>
              </router-link>
            </nav>
          </div>
          <div>
            <div class="footer-column footer-contact">
              <h4 class="footer-heading">{{ $t('footer.headings.contact') }}</h4>
              <div class="footer-contact-list">
                <a href="tel:+32123456789">
                  <div>
                    <div class="footer-contact-item">
                      <span class="footer-contact-icon">
                        <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                          <path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233a14 14 0 0 0 6.392 6.384"
                            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                      </span>
                      <span>+32 (0)89819330</span>
                    </div>
                  </div>
                </a>
                <a href="mailto:info@vlecad.com">
                  <div>
                    <div class="footer-contact-item">
                      <span class="footer-contact-icon">
                        <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                          <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="m22 7l-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path>
                            <rect x="2" y="4" rx="2" width="20" height="16"></rect>
                          </g>
                        </svg>
                      </span>
                      <span>info@vlecad.com</span>
                    </div>
                  </div>
                </a>
                <div class="footer-contact-item">
                  <span class="footer-contact-icon">
                    <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                      <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M17.97 9.304A8 8 0 0 0 2 10c0 4.69 4.887 9.562 7.022 11.468m12.356-4.842a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z"></path>
                        <circle r="3" cx="10" cy="10"></circle>
                      </g>
                    </svg>
                  </span>
                  <span>
                    <span>Kanaalkom 36</span>
                    <br />
                    <span>3960 Bree</span>
                    <br />
                    <span>{{ $t('footer.contact.addressLine3') }}</span>
                  </span>
                </div>
              </div>
              <div class="footer-social-links">
                <a href="https://www.instagram.com/vlecad/" target="_blank" rel="noreferrer noopener">
                  <div rel="noreferrer noopener" target="_blank" class="footer-container18">
                    <div rel="noopener" target="_blank" aria-label="Instagram" class="footer-social-link">
                      <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                        <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <rect x="2" y="2" rx="5" ry="5" width="20" height="20"></rect>
                          <path d="M16 11.37A4 4 0 1 1 12.63 8A4 4 0 0 1 16 11.37m1.5-4.87h.01"></path>
                        </g>
                      </svg>
                    </div>
                  </div>
                </a>
                <a href="https://www.facebook.com/vlecad/" target="_blank" rel="noreferrer noopener">
                  <div rel="noreferrer noopener" target="_blank">
                    <div rel="noopener" target="_blank" aria-label="Facebook" class="footer-social-link">
                      <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                        <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                      </svg>
                    </div>
                  </div>
                </a>
                <a href="https://be.linkedin.com/company/vlecad-bvba" target="_blank" rel="noreferrer noopener">
                  <div rel="noreferrer noopener" target="_blank">
                    <div rel="noopener" target="_blank" aria-label="LinkedIn" class="footer-social-link">
                      <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                        <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2a2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6M2 9h4v12H2z"></path>
                          <circle r="2" cx="4" cy="4"></circle>
                        </g>
                      </svg>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="footer-cta-bar">
          <div class="footer-cta-content">
            <div class="footer-cta-text">
              <h3 class="footer-cta-title">{{ $t('footer.headings.ctaTitle') }}</h3>
              <p class="footer-cta-subtitle">{{ $t('footer.cta.subtitle') }}</p>
            </div>
            <router-link to="/contactdemo">
              <div class="footer-thq-btn-elm1 btn btn-lg btn-primary">
                <button @click="scrollToTop">
                  {{ $t('footer.cta.button') }}
                </button>
              </div>
            </router-link>
          </div>
        </div>
        <div class="footer-newsletter">
          <div class="footer-newsletter-content">
            <div class="footer-newsletter-text">
              <h4 class="footer-newsletter-title">{{ $t('footer.headings.newsletter') }}</h4>
              <p class="footer-newsletter-description">{{ $t('footer.newsletter.description') }}</p>
            </div>
            <form aria-label="Newsletter signup" data-form-id="28caf4e1-6245-49d1-a0fc-8a14a6735118" class="footer-newsletter-form">
              <input type="email" name="textinput ysub9xvj4a" required="true" aria-label="Email address" placeholder="your@email.com" class="footer-newsletter-input"/>
              <button name="button t1uqe7yn09" type="submit" class="btn btn-secondary">
                {{ $t('footer.newsletter.subscribe') }}
              </button>
            </form>
          </div>
        </div>
        <div class="footer-bottom">
          <div class="footer-bottom-left">
            <p class="footer-copyright">{{ $t('footer.copyright') }}</p>
          </div>
          <div class="footer-bottom-right">
            <a href="#">
              <div class="footer-legal-link"><span>{{ $t('footer.links.privacy') }}</span></div>
            </a>
            <span class="footer-divider">•</span>
            <a href="#">
              <div class="footer-legal-link"><span>{{ $t('footer.links.terms') }}</span></div>
            </a>
            <span class="footer-divider">•</span>
            <a href="#" @click.prevent="$emit('show-cookies')">
              <div class="footer-legal-link"><span>{{ $t('footer.links.cookies') }}</span></div>
            </a>
          </div>
        </div>
      </div>
      <button id="footer-back-to-top" aria-label="Back to top" class="footer-back-to-top">
        <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
          <path d="m5 12l7-7l7 7m-7 7V5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>
      </button>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  emits: ['show-cookies'],
  props: {
    imageSrc: {
      type: String,
      default: '/logo_korpus-registered-200h.png',
    },
    imageAlt: {
      type: String,
      default: 'image',
    },
  },
  mounted() {
    // Vue 3 migration/security: move inline scripts into component lifecycle hooks.
    const cleanupHandlers = []
    const addListener = (target, event, handler, options) => {
      if (!target) {
        return
      }
      target.addEventListener(event, handler, options)
      cleanupHandlers.push(() => target.removeEventListener(event, handler))
    }

    const backToTopButton = document.getElementById('footer-back-to-top')
    const toggleBackToTopButton = () => {
      if (!backToTopButton) {
        return
      }
      backToTopButton.classList.toggle('visible', window.scrollY > 500)
    }

    let scrollTimeout
    const handleScroll = () => {
      if (scrollTimeout) {
        window.cancelAnimationFrame(scrollTimeout)
      }
      scrollTimeout = window.requestAnimationFrame(toggleBackToTopButton)
    }

    addListener(window, 'scroll', handleScroll, { passive: true })
    addListener(backToTopButton, 'click', () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    })

    const newsletterForm = document.querySelector('.footer-newsletter-form')
    const handleNewsletterSubmit = (event) => {
      event.preventDefault()
      const emailInput = event.currentTarget.querySelector(
        '.footer-newsletter-input'
      )
      const email = emailInput?.value
      if (!emailInput) {
        return
      }

      // Placeholder for backend integration; keep UI feedback local.
      console.log('Newsletter signup:', email)

      const button = event.currentTarget.querySelector('.btn')
      const originalText = button?.textContent
      if (button) {
        button.textContent = 'Subscribed!'
        button.style.background = 'var(--color-primary)'
        button.style.color = 'var(--color-on-primary)'
      }

      emailInput.value = ''

      setTimeout(() => {
        if (button) {
          button.textContent = originalText
          button.style.background = ''
          button.style.color = ''
        }
      }, 3000)
    }

    addListener(newsletterForm, 'submit', handleNewsletterSubmit)
    toggleBackToTopButton()

    this._cleanupFooter = () => {
      cleanupHandlers.forEach((handler) => handler())
      cleanupHandlers.length = 0
      if (scrollTimeout) {
        window.cancelAnimationFrame(scrollTimeout)
      }
    }
  },
  beforeUnmount() {
    if (this._cleanupFooter) {
      this._cleanupFooter()
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }    
  }
}
</script>

<style>
@media (prefers-reduced-motion: no-preference) {
  .footer-link,
  .footer-contact-item,
  .footer-social-link {
    transition: all 0.3s var(--animation-curve-primary);
  }
  .footer-badge {
    animation: fadeInUp 0.6s var(--animation-curve-primary) backwards;
  }
  .footer-badge:nth-child(1) {
    animation-delay: 0.1s;
  }
  .footer-badge:nth-child(2) {
    animation-delay: 0.2s;
  }
  .footer-badge:nth-child(3) {
    animation-delay: 0.3s;
  }
}
@media (prefers-reduced-motion: reduce) {
  * {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}
</style>

<style scoped>
.footer-container10 {
  display: contents;
}
 
.footer-container11 {
  display: none;
}
 
.footer-container12 {
  display: contents;
}
 
.footer-container13 {
  display: none;
}
 
.footer-container14 {
  display: contents;
}
 
.footer-image {
  width: 200px;
  object-fit: cover;
}
 
.footer-thq-footer-column-elm3 {
  display: none;
}
 
.footer-thq-footer-link-elm19 {
  display: none;
}
 
.footer-thq-footer-link-elm24 {
  text-decoration: none;
}
 
.footer-container18 {
  text-decoration: none;
}
 
.footer-thq-btn-elm1 {
  text-decoration: none;
}
</style>
